import type { ReactNode } from "react";
import { Button } from "../../../components/Button/Button.tsx";
import { useImageDropZone } from "../../../hooks/useImageDropZone.ts";

export const ImageDropZone = ({
  onDrop,
  content,
  className,
  minImageSideDimension = 256,
}: {
  onDrop: (file: { fileToUpload: File; uuid: string } | undefined) => void;
  content: ReactNode;
  className?: string;
  minImageSideDimension?: number;
}) => {
  const {
    getRootProps,
    getInputProps,
    open: openFileBrowser,
  } = useImageDropZone({
    multiple: false,
    minImageSize: minImageSideDimension,
    onImageValidated: onDrop,
  });

  return (
    <div
      {...getRootProps()}
      className="w-full flex-fill flex-col-center gap-200
      bg-input-surface-rest"
    >
      <input {...getInputProps()} />
      {content}

      <Button
        variant="primary"
        onClick={() => openFileBrowser()}
        className={className}
      >
        <input {...getInputProps()} />
        Browse files
      </Button>
    </div>
  );
};
